module.exports = __webpack_public_path__ + "fonts/AvenyTWEB.e486bd77.eot";